export interface PostBlogTagModel {
    name: string;
    color: string;
}

export class BlogTagDetailsModel {
    id: string;
    color: string;
    name: string;
}